"use strict";
exports.__esModule = true;
exports.Avatar = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var class_names_1 = tslib_1.__importDefault(require("../utils/helpers/class-names"));
var avatar_style_1 = require("./avatar.style");
var text_1 = tslib_1.__importDefault(require("../text"));
var div_1 = tslib_1.__importDefault(require("../div"));
var badge_1 = tslib_1.__importDefault(require("../badge/badge"));
var Avatar = function (_a) {
    var className = _a.className, _b = _a.alt, alt = _b === void 0 ? 'آواتار' : _b, _c = _a.size, size = _c === void 0 ? 'base' : _c, _d = _a.rounded, rounded = _d === void 0 ? "medium" : _d, _e = _a.isOnline, isOnline = _e === void 0 ? true : _e, src = _a.src, BadgeProps = _a.BadgeProps, rest = tslib_1.__rest(_a, ["className", "alt", "size", "rounded", "isOnline", "src", "BadgeProps"]);
    var Children = (react_1["default"].createElement("img", tslib_1.__assign({ className: (0, class_names_1["default"])('rounded-full', className, avatar_style_1.AVATAR_SIZES[size], avatar_style_1.AVATAR_SHAPE[rounded]), src: src, alt: alt, loading: "lazy" }, rest)));
    if (!src) {
        Children = (react_1["default"].createElement(div_1["default"], { className: (0, class_names_1["default"])('flex items-center justify-center border border-control-100 shadow', className, avatar_style_1.AVATAR_SIZES[size], avatar_style_1.AVATAR_SHAPE[rounded]) },
            react_1["default"].createElement(text_1["default"], { type: 'regular', typography: size }, alt.charAt(0))));
    }
    if (isOnline) {
        return (react_1["default"].createElement(badge_1["default"], tslib_1.__assign({ variant: "dot", badgeContent: 0, anchorSituation: 'inner', size: size }, BadgeProps, { children: Children })));
    }
    return (Children);
};
exports.Avatar = Avatar;
exports["default"] = exports.Avatar;
//# sourceMappingURL=avatar.js.map